<template>
  <div class="applyInfo">
    <van-overlay :show="showOverlay"/>
    <van-nav-bar
        title="取牌确认"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    <div class="search">
      <div class="dataTime">
        <div class="search">
          <!-- <van-cell-group>
            <van-search
              v-model="searchPlateNoValue"
              placeholder="请输入车牌号查询"
              @input="queryInfo"
              @search="queryInfo"
            />
            <van-row>
            <van-col :span="12">
              <van-cell title="查询状态：" :value="searchState" @click="showBegin = true" />
            </van-col>
            <van-col :span="12">
              <van-dropdown-menu>
                <van-dropdown-item v-model="value1" :options="option1" />
              </van-dropdown-menu>
            </van-col> 
          </van-row>
          </van-cell-group> -->
          <van-search
            v-model="searchPlateNoValue"
            placeholder="请输入车牌号码查询"
            @input="queryInfo"
            @search="queryInfo"
          />
          <van-cell style="padding: 0 15px;">
            <van-row>
              <van-col :span="12" >
                <van-cell title="查询状态：" :value="searchState" @click="showBegin = true" />
              </van-col>
              <van-col :span="12">
                <van-dropdown-menu>
                  <van-dropdown-item v-model="value1" :options="option1" @change="selectState(value1)"/>
                </van-dropdown-menu>
              </van-col> 
            </van-row>
          </van-cell>
          <!-- <van-divider /> -->
        </div>
        <van-row>
          <van-cell title="查询开始时间：" is-link :value="dataForm.dateBegin" @click="clickBegin(dataForm.dateBegin)" />
          <van-calendar ref="vanCalendar" v-model="showBegin" :value="dataForm.dateBegin" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmBegin" />
        </van-row>
        <van-row>
          <van-cell title="查询结束时间：" is-link :value="dataForm.dateEnd" @click="showEnd = true" />
          <van-calendar v-model="showEnd" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmEnd" />
          <span style="color: #fa8f04;font-weight: bold; font-size: 13px;
            float: right;margin-right: 6%;">{{ queryDataLength }}</span>
        </van-row>
        <!-- <van-divider style="margin: 0;" /> -->
          <!-- <van-row style="margin:0 12px;">
          <van-button round block plain hairline type="info"  @click="onSearch">查 询</van-button>
        </van-row> -->
      </div>
    </div>
    <div class="searchContent">
      <!-- <van-list
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-cell v-for="item in queryDataArray" :key="item.id" >
          <van-row>
            <van-col :span="16">
              <van-row>
                <van-col :span="10" style="text-align: right;">车牌号码：</van-col>
                <van-col :span="12" style="text-align: center;">{{ item.plateNo }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="6">
              <van-button  style="height: 42px; width: 120%;"   hairline :type="item.state == 2 ?'primary' :'info'" @click="showDetail(item)"
               :disabled="item.state<2?true:false"
               >{{ item.state==0?'已登记': item.state==1?'待取出': item.state==2?'确认取出':'到达服务站' }}</van-button>
            </van-col>
          </van-row>
        </van-cell>
      </van-list> -->
      <van-list
        :finished="finished"
        finished-text="没有更多了"
      >

        <van-swipe-cell v-for="item in queryDataArray" :key="item.id" style="font-size: 20px;margin: 5px 0 5px 10px;">
            <van-row>
            <van-col :span="16">
              <van-row>
                <van-col :span="10" style="text-align: right;">车牌号码：</van-col>
                <van-col :span="12" style="text-align: center;">{{ item.plateNo }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="6">
              <van-button  style="height: 42px; width: 120%;padding: 10px;"   hairline :type="item.state == 2 ?'primary' :'info'" @click="showDetail(item)"
               :disabled="item.state<2?true:false"
               >{{ item.state==0?'已登记': item.state==1?'待取出': item.state==2?'确认取出':'到达服务站' }}</van-button>
            </van-col>
          </van-row>
        <template #right>
          <van-button style="height: 42px;" type="danger"  text="删除" @click="onDelete(item)" v-show="item.state == 0"/>
        </template>
      </van-swipe-cell>
      </van-list>
    </div>
    <!-- 0.42667rem -->
    <!-- 450881200010058922 -->
    <!-- 编辑申请信息 -->
        <van-overlay :show="showDataDetail" @click="showDataDetail=false">
          <div class="wrapper" @click.stop>
            <div class="applyBlock">
              <van-form>
                <div class="title">
                <!-- <span>{{ showList.state == 0?'编辑申请信息':'查看申请信息' }}
                  <van-icon name="close" class="cancel" @click="cancelForm"/>
                </span> -->
                <span>查看取牌信息
                  <van-icon name="close" class="cancel" @click="cancelForm"/>
                </span>
              </div>
              <van-field label="车牌号码：" v-model="showList.plateNo" disabled>
              </van-field>
              <van-field label="身份证号："  v-model="showList.idNo" disabled/>
              <van-field label="取出时间："  v-model="showList.getTime" disabled/>
              <van-field label="确认时间："  v-model="showList.confirmTime" disabled/>
              <van-field label="到站时间："  v-model="showList.arriveTime" disabled/>
              <van-field label="创建时间："  v-model="showList.createTime" disabled/>
              <!-- <van-field label="存放位置：" v-model="showList.boxCode" disabled/>
              <van-field label="车牌类型：" :disabled="showList.state == 0 ? false:true">
                <template #input>
                  <van-radio-group v-model="showList.plateType" direction="horizontal" :disabled="showList.state == 0 ? false:true">
                    <van-radio :name= 0 checked-color="#3399ff">蓝牌</van-radio>
                    <van-radio :name= 1 checked-color="#3399ff">绿牌</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              
              <van-field label="申请状态：" v-model="showList.stateDescription" disabled />
              <van-field label="创建时间： " v-model="showList.createTime" disabled/> -->
              </van-form>
              <div style="margin: 16px;">
                <van-button round block plain hairline type="info" @click="showPhoto(showList)" v-show="showList.photo==null?false:true">
                  查看照片</van-button>
                <!-- <van-button round block plain hairline type="info" @click="confirmFrom(showList)" style="margin-top: 10px;">
                  确 定</van-button> -->
                  <van-button round block type="info" @click="confirmFrom(showList)" style="margin-top: 10px;">
                    确 定</van-button>
              </div>
            </div>
          </div>
        </van-overlay>

          <van-popup v-model="show" >
          <div class="imgBox">
            <van-loading size="30px" type="spinner" color="#1989fa" v-show="loadingImg"></van-loading>
            <img :src="imgSrc" v-if="!loadingImg" >
          </div>
          </van-popup>
  </div>
</template>

<script>
import {ModifyApplyInfo,QueryApplyPhoto,QueryStationTask,UpdateTaskState} from '@/my_js//HttpRequest.js'
import {formatTime,getNowTime,formatDateTime,formatBeginTime,formatEndTime} from '@/utils/date.js'
import { Notify,Dialog,SwipeCell} from 'vant'
import PlateNumber from '../plateNo.vue'
import store from '../../store'
export default {
  // mounted(){
  //   this.echartsInit()
  // },
  components:{
    PlateNumber,
  },
  filters:{
    formatTime:function(inputTime){
     return formatTime(inputTime)
    }
  },
 
  data(){
    return{
      dataForm:{
        id:'',
        applyState:-1,//申请状态
        plateType:-1,//车牌类型
        plateNo:'',//车牌号
        // idNo:'450881200010108922',
        idNo:'',//身份证号
        phoneNo:'',//手机号
        verifyNo:'',//验证码
        userPhoneNo:'',//管理员手机号
        dateBegin:null,//开始时间
        dateEnd:null,//结束时间
      },
      // exitDisable:false,//编辑按钮禁用
      isPlateNo:false,//是否为车牌号
      radio:'1',//1：身份证号查询，2：车牌号查询
      searchIdNoValue:'',//身份证号搜索内容
      searchPlateNoValue:'',//车牌号搜索内容
      searchState:'',//查询状态
      // list:[],
      loading:false,
      loadingImg:false,
      finished:false,
      responseDataArray:[],//响应数据
      queryDataArray:[],//查询数据
      showDataDetail:false,//详情显示
      showList:[],//详情信息列表
      confirmShow:false,//修改确认
      // userName:'',//用户名
      confirmForm:{
        userPhoneNo:'',//身份证号
        userName:'',//用户名
      },
      showBegin:false,
      selectDate:null,//选中的日期
      showEnd:false,
      minDate:new Date(2020,0,1),
      // maxDate:new Date(2050,12,31),
      maxDate:new Date(new Date().setFullYear(new Date().getFullYear() + 1)), // 最大日期为当前日期加一年
      show:false,//是否显示图片
      imgSrc:null,//图片 base64 字符串
      zoom:1,
      value1:2,//查询状态默认值
      option1:[
        {text:'已登记',value:0},
        {text:'待取出',value:1},
        {text:'待确认',value:2},
        {text:'到达服务站',value:3},
      ],
      showOverlay:false,//显示遮罩层
      queryDataLength:null,//查询到的数据量
      
    }
  },
  mounted(){
    const end = new Date()
    const start = new Date()
    end.setTime(start.getTime() - 3600 * 1000 * 24 * 30)//默认查询30天时间
    const data = formatDateTime(end)
    console.log(data);
    this.dataForm.dateBegin = data
    this.dataForm.dateEnd = getNowTime()//当天时间
    this.onSearch()

    // this.image()

  },
  // watch:{
  //   showBegin(val){
  //     if(val){
  //       // 当日历展开，将选中的日期设置为 dataForm.dateBegin
  //       this.selectDate = this.dataForm.dateBegin
  //     }
  //   }
  // },
  methods:{
    // 返回
    goBack(){
      console.log('返回服务站首页');
      this.$router.push('/stationIndex')
    },
    // 搜索
    onSearch(val){
      this.loading = true
      console.log('搜索输入内容：',val);
      const beginTime = formatBeginTime(this.dataForm.dateBegin)
      const endTime = formatEndTime(this.dataForm.dateEnd)
      const dataArray = {
        stationCode:store.state.stationUserInfo.stationCode,//工作站
        // stationCode:'130100008133',//工作站
        state:-1,
        plateNo:'',//车牌号
        idNo:'',//身份证号
        dateBegin:beginTime,//开始时间
        dateEnd:endTime,//结束时间
      }
      console.log('dataArray:',dataArray);
      QueryStationTask(dataArray).then(res =>{
          console.log(res);
          // this.responseDataArray = res.data
          this.responseDataArray = res.data.filter(item => 
            (item.state == 0 || item.state == 1 || item.state == 2 || item.state == 3)
          )
          // this.queryDataArray = this.responseDataArray
          console.log( 'this.responseDataArray',this.responseDataArray);
          this.finished = true
          this.loading=false
          this.selectState(this.value1)
        })
      
    },
    // 查询数据
    queryInfo(){
      // 将输入的身份证号和车牌号转换为大写
      // const formattedIdNo = this.trimmedStr(this.searchIdNoValue).toUpperCase();
      const formattedPlateNo = this.trimmedStr(this.searchPlateNoValue).toUpperCase();
      // console.log('formattedIdNo',formattedIdNo);
      console.log('formattedPlateNo',formattedPlateNo);
      
      // 按照车牌号进行查询
     if (formattedPlateNo) {
        this.queryByPlateNo(formattedPlateNo);
      } else if(this.value1){
        this.selectState()
      }else{
        console.log('请输入搜索条件');
        this.onSearch()
      }

    },
     // 车牌号查询
     queryByPlateNo(plateNo){
      // console.log('车牌号查询');
      // if(plateNo == null || plateNo == ''){
      //   this.onSearch()
      // }
      // 根据车牌号查询逻辑
      const filteredData = this.responseDataArray.filter(item =>
        item.plateNo.includes(plateNo)
      );
      console.log('车牌号查询结果:', filteredData);
      
      if(filteredData.length != 0){
        this.queryDataArray = filteredData
        console.log('filteredData',this.filteredData);
        this.queryDataLength = this.queryDataArray.length
      }else{
        this.queryDataArray = filteredData
        this.queryDataLength = null
        Notify({message:'暂无该车牌号信息，请稍后再查询',type:'warning'})
      }
     },
    // 去除空格
    trimmedStr(str){
      return str.replace(/\s+/g,'')
    },
    // 查看数据详情
    showDetail(val){
      // debugger
      console.log('val',val);
      
      const data = {
            id:val.id,
            stationCode:val.stationCode,//工作站
            idNo:val.idNo,
            plateNo:val.plateNo,
            state:null,
          }
      if(val.state == 2){
        Dialog.confirm({
          title:'消息确认',
          message:`是否确定取出该车牌？`
        }).then(()=>{
          this.showOverlay = true
          console.log('点击了确定取出该车牌');
          // const data = {
          //   id:'',
          //   stationCode:val.stationCode,//工作站
          //   idNo:val.idNo,
          //   plateNo:val.plateNo,
          //   state:val.state,
          // }
          console.log('data',data);
          data.state = 3
          UpdateTaskState(data).then(res => {
            this.showOverlay = false
            console.log(res);
            this.onSearch()
            Notify({message:'取出车牌'+ res.msg,type:'success'})
            
          })
          // this.onSearch()
        }).catch(error =>{
          console.log(error);
        })
      }else if (val.state == 3){
        Dialog.confirm({
          title:'消息确认',
          message:`是否确定车牌已到达服务站？`
        }).then(()=>{
          this.showOverlay = true
          console.log('点击了确定车牌已到达服务站');
          console.log('data',data);

          data.state = 4
          UpdateTaskState(data).then(res => {
            this.showOverlay = false
            console.log(res);
            this.onSearch()
            Notify({message:'设置车牌到达服务站'+ res.msg,type:'success'})
            
          })
          // this.onSearch()
        }).catch(error =>{
          console.log(error);
        })
      }
    },
     // 获取车牌号
    getPlateNo(data){
        this.showList.plateNo = data
    },
    // 关闭编辑页面
    cancelForm(){
      // 清空搜索信息
      this.searchIdNoValue = ''
      this.searchPlateNoValue = ''
      this.onSearch()
      this.showDataDetail = false
    },
    // 提交修改数据
    confirmFrom(val){
      // debugger
      console.log(val);
      if(val.state != 0){
        this.showDataDetail = false
        // 清空搜索信息
        this.searchIdNoValue = ''
        this.searchPlateNoValue = ''
        this.onSearch()
      }else if (val.state == 0){
        // 验证身份证号
        const reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
        const reg1 = new RegExp(/^[A-Z]\d{7,11}$/)
        if(!reg1.test(val.idNo) && !reg.test(val.idNo)){
          Notify({type:'warning',message:'请输入正确的身份证号'})
          return
        }

        if((this.showList.plateType == 0 && this.showList.plateNo.length != 7) || (this.showList.plateType == 1 && this.showList.plateNo.length != 8)){
          Notify({type:'warning',message:'请输入正确的车牌号',duration:2000})
          return
        }
        Dialog.confirm({
          title: '提示',
          message: '是否确定修改该用户的信息？',
        })
        .then(() => {
          // on confirm
          console.log('点击了确定');
          const dataArray = {
          id:this.showList.id,
          applyState:this.showList.state,
          plateType:this.showList.plateType,
          plateNo:this.showList.plateNo,
          idNo:this.showList.idNo,
          // userPhoneNo:this.confirmForm.userPhoneNo
          }   
          console.log('dataArray',dataArray);
          console.log(JSON.stringify(dataArray));
          ModifyApplyInfo(dataArray).then(res =>{
            console.log('修改申请数据：',res);
            Notify({type:'success',message:'修改'+res.msg})
            this.showDataDetail = false
            // 清空搜索信息
            this.searchIdNoValue = ''
            this.searchPlateNoValue = ''
            this.onSearch()
          })
        })
        .catch(() => {
          // on cancel
          console.log('点击了取消');
          this.showDataDetail = false
          // 清空搜索信息
          this.searchIdNoValue = ''
          this.searchPlateNoValue = ''
          this.onSearch()
        });
      }
      
    },
     // 选择日期并格式化时间
      onConfirmBegin(date){
        this.showBegin = false
        // 格式化时间
        this.dataForm.dateBegin = formatDateTime(date)
        console.log('开始时间：',this.dataForm.dateBegin);
        this.onSearch()
      },
      // 点击开始时间
      clickBegin(date){
        this.showBegin = true
        this.$nextTick(() => {
            this.$refs.vanCalendar.reset(new Date(date))// 确保日历定位到指定时间
        })
      },
      // 选择日期并格式化时间
      onConfirmEnd(date){
      this.showEnd = false
      // 格式化时间
      this.dataForm.dateEnd = formatDateTime(date)
      console.log('结束时间：',this.dataForm.dateEnd);
      this.onSearch()
      },
      // 查看照片
      showPhoto(val){
        // debugger
        this.show = true
        this.loadingImg = true
        console.log(val);
        const photoPath = val.photo
        console.log('照片路径：',photoPath);
        QueryApplyPhoto(photoPath).then(res => {
          console.log(res);
          if(res.code == 0){
            // 查询图片成功
            // console.log(res.data);
            // 把返回的 base64 数据拼接上图片格式
            this.imgSrc = "data:image/png;base64,"+ res.data
            // this.show = true
            this.loadingImg = false
            this.image()
          }else{
            Notify({type:'warning',message:res.msg})
          }
        })
      },
      // 图片放大缩小
      image(){
        const content = document.querySelector('.imgBox')//获取需要放大缩小的盒子
        let firstDistance = 0 //存放手指开始放上的时候，两根手指之间的距离
        // 缩放事件的处理
        const getDistance = (start,stop) => {
          // 计算两根手指之间的距离
          return Math.sqrt(Math.pow(Math.abs(start.x - stop.x),2) + Math.pow(Math.abs(start.y - stop.y),2))
        }
        content.addEventListener('touchstart',function(event){
          // 获取第一次触摸的点
          const touches = event.touches
          if(touches.length > 1){// 判断是否是两指
            const events1 = touches[0]
            const events2 = touches[1]
            const one = {
              x:events1.pageX,//第一根手指的横坐标
              y:events1.pageY,//第一根手指的纵坐标
            }
            const two = {
              x:events2.pageX,//第二根手指的横坐标
              y:events2.pageY,//第二根手指的纵坐标
            }
            firstDistance = getDistance(one,two)
          }
        })
        document.addEventListener('touchmove',(event) => {
          const touches = event.touches
          if(touches.length > 1){
            const events1 = touches[0]
            const events2 = touches[1]
            const one = {
              x:events1.pageX,//第一根手指的横坐标
              y:events1.pageY,//第一根手指的纵坐标
            }
            const two = {
              x:events2.pageX,//第二根手指的横坐标
              y:events2.pageY,//第二根手指的纵坐标
            }
            const distance = getDistance(one,two)
            let zoom = distance / firstDistance
            content.style.zoom = this.zoom * zoom
          }
        })
        document.addEventListener('touchend',(event) => {
          this.zoom = content.style.zoom
        })
      },
      // 状态查询，用户选择的状态
      selectState(val){
        const filterData = this.responseDataArray.filter(item => item.state==val)
        console.log('filterData',filterData);
        this.queryDataArray = filterData
        if(filterData.length != 0){
          this.queryDataLength = this.queryDataArray.length
        }
        
      },
      // 删除
      onDelete(item){
        console.log('点击了删除item',item);
        const data = {
          id:item.id,
          stationCode:item.stationCode,
          idNo:item.idNo,
          plateNo:item.plateNo,
          state:-2,
        }
        console.log('data',data);
        
        Dialog.confirm({
          title:'提 示',
          message:`确认删除 ${item.plateNo} 的登记信息？删除后，将无法取出该车牌！`
        }).then(()=>{
          console.log('点击了确定删除车牌信息');
          UpdateTaskState(data).then(res => {
            console.log(res);
            Notify({message:'删除'+res.msg,type:'success'})
            this.onSearch()
            
          }) 
         
        }).catch(error =>{
          console.log(error);
        })
        
      }

   
  }

}
</script>

<style lang="scss" >
.applyInfo{
  .dataTime{
    .search{
      // .radio{
      //   margin-top: 2%;
      //   font-size: 15px;
      //   display: flex;
      //   // justify-content: center;
      //   justify-content: space-around;
      // }
    }
  }
  .searchContent{
    .van-cell__title{
      line-height: 45px;
    }
    .van-dialog__header{
        color: #000;
      }
    .van-dialog__message--has-title{
      color: #ff9900;
      text-align: left;
    }
  }

  .van-nav-bar__left{
    left: 0;
  }
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .van-search__action{
    color: #0283ef;
    font-size: 18px;
  }

  .wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .title{
    margin-top: 3%;
    .cancel{
      float: right;
      margin-right: 3%;
      font-size: 28px;
    }
  }
  .applyBlock{
    width: 95%;
    // height: 68%;
    border-radius: 8px;
    background-color: #fff;
    .van-cell__value{
      text-align: left;
    }
    .van-field__control{
      width: 90%;
    }
  }
  .picWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

.picBlock {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

}
.van-hairline--bottom::after{
  border: none;
}
.van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
</style>